import * as React from "react";
import { toast } from "@grandvisionhq/common";
import { useMutation } from "@grandvisionhq/graphql";
import { useCartStorage } from "@grandvisionhq/lib-utils-cart";
import { useDispatchTrackErrorEvent } from "@grandvisionhq/svc-tealium/events";
import { isNil } from "@grandvisionhq/utils";
import { getValidationErrorCodes } from "../../utils/utils/get-validation-error-codes.js";
import { DUPLICATE_CART_LINE_ITEMS } from "../../operations/mutations/operations/mutations/duplicate-cart-line-items.js";
const useDuplicateCartLineItems = (lineItem, onSuccess) => {
  const [{ cartId }, { setCartCount }] = useCartStorage();
  const handleValidationErrors = (validationErrors) => {
    validationErrors.forEach((validationError) => toast.failed(`cart.${validationError}`));
  };
  const dispatchTrackErrorEvent = useDispatchTrackErrorEvent();
  const handleTrackErrorTealium = React.useCallback(
    (errorDetails, errorMessage) => dispatchTrackErrorEvent(
      () => Promise.resolve({
        Error_Source: "Server",
        Error_Code: "Duplicate cart error",
        Error_Details: errorDetails,
        ...errorMessage ? { Error_Message: errorMessage } : {}
      })
    ),
    [dispatchTrackErrorEvent]
  );
  const [duplicateCartLineItems, duplicateCartLineItemsMutation] = useMutation(DUPLICATE_CART_LINE_ITEMS, {
    onCompleted: (response) => {
      if ("duplicateCartLineItems" in response) {
        const { success, cart, validationErrors } = response.duplicateCartLineItems;
        success && cart && setCartCount(cart.numberOfItems);
        if (!success && validationErrors) {
          const validationErrorCodes = getValidationErrorCodes(validationErrors);
          handleValidationErrors(validationErrorCodes);
        }
      }
      onSuccess && onSuccess();
    }
  });
  const duplicateToCart = React.useCallback(() => {
    if (isNil(cartId)) {
      console.error("No cart ID available");
      handleTrackErrorTealium("No cart ID available");
      return;
    }
    duplicateCartLineItems({
      variables: {
        cartInput: {
          cartId,
          lineItems: [
            {
              id: lineItem.id
            }
          ]
        }
      }
    });
  }, [cartId, duplicateCartLineItems, lineItem.id, handleTrackErrorTealium]);
  const { called, loading, error } = duplicateCartLineItemsMutation;
  return [duplicateToCart, { called, loading, error }];
};
export {
  useDuplicateCartLineItems
};
//# sourceMappingURL=use-duplicate-cart-line-items.js.map
